import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M39.2401 4.05995C43.1001 7.16995 46.7602 14.67 42.5302 29.95C38.2902 45.23 21.5201 62.26 5.89014 54.01C5.89014 54.01 14.8601 54.93 14.8301 42.32C14.8101 29.7 13.7102 15.96 20.2802 7.57997C26.8402 -0.800034 35.8501 1.32995 39.2401 4.05995Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9 54.92C9 54.92 18.36 55.65 21.06 45.51C25.57 28.5 22.6 8.35002 33.34 3.90002C33.34 3.90002 37.47 8.35996 36.15 24.21C35.27 34.74 27.73 57.24 12.15 55.75"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M33.3302 3.89001C33.3302 3.89001 18.9602 4.22 18.9102 33.12C18.8802 48.49 15.2802 54.26 9.66016 54.42"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
